// /home/ananun/fluorescence.pro/admin/src/helpers/userContext.jsx
// userContext.jsx

import { useContext, createContext } from "react";

export const UserContext = createContext();

export function useUser() {
  return useContext(UserContext);
}
